export const spanishComingSoonCopy = {
  header: '',
  description: '',
  confirmBtnText: '',
};
